export default {
  OK: "ok",
  ALARM: "alarm",
  WARNING: "warning",
  ERROR: "error"
};
